<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
      <b-col sm="5"><label for="input-none">サービス</label></b-col>
        <div v-if="user && user.role == 'admin'" class="ml-auto p-2 align-middle">
          <el-button type="warning" icon="el-icon-plus" circle v-on:click="addButton()"></el-button>
        </div>
      </b-row>
        <b-card-body>
          <b-row>
            <b-col>
              <div class="table-responsive">
                <b-table
                  :items="filteredService"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="icon" class="avatar" slot-scope="item">
                    <b-img v-if="item.value" :src="item.value" width="40" height="40"></b-img>
                    <!-- <b-img v-else src="../admin.png" width="40" height="40" class="img-avatar"></b-img> -->
                  </div>
                  <div slot='users' slot-scope='item'>
                    {{ getUsers(item) }}
                  </div>
                  <div slot='updatedAt' slot-scope='item'>
                    {{ item.value * 1000 | moment }}
                  </div>
                  <div slot='createdAt' slot-scope='item'>
                    {{ item.value * 1000 | moment }}
                  </div>
                  <div slot="key" slot-scope="item">
                    <p v-if='user.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                    <div class="mr-auto align-middle">
                      <el-button type="success" icon="el-icon-edit" circle v-on:click="editButton(item.value)"></el-button>
                    </div>
                  </div>
                </b-table>
              </div>
              <b-pagination align="center" size="sm" :total-rows="services.length" v-model="currentPage" :per-page="perPage"></b-pagination>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        subTitle: {
          label: '説明',
          class: 'text-center',
          sortable: true
        },
        users: {
          label: '登録人数',
          class: 'text-center'
        },
        updatedAt: {
          label: '更新日時',
          class: 'text-center m-0',
          sortable: true
        },
        createdAt: {
          label: '作成日時',
          class: 'text-center m-0',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 10,
      filteredService: [],
      unwatch: null
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
  },
  created () {
    this.unwatch = this.$watch((vm) => [vm.$store.getters['service/services'], vm.$store.getters['authUser/user']], function () {
      this.init()
    })
    this.init()
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      user: 'authUser/user'
    })
  },
  methods: {
    init () {
      this.filteredService = []
      if (this.user && this.user.role === 'admin') {
        this.filteredService = this.services
      } else if (this.user && this.user.role === 'owner') {
        var keys = Object.keys(this.user.services)
        for (var i = 0; i < keys.length; i++) {
          if (this.user.services[keys[i]]) {
            const index = this.services.findIndex(service => service.key === keys[i])
            if (index !== -1) {
              this.filteredService.push(this.services[index])
            }
          }
        }
      }
    },
    editButton (key) {
      this.$store.dispatch('dispatch/setService', key).then(() => {
        this.$router.push({path: 'services/edit'})
      })
    },
    addButton () {
      this.$store.dispatch('dispatch/setService', null).then(() => {
        this.$router.push({path: 'services/register'})
      })
    },
    getUsers (value) {
      var number = 0
      for (var index in value.item.users) {
        if (value.item.users[index]) {
          number += 1
        }
      }
      return number
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Services.vue